import React from 'react';

const WelcomeAdmin = () => {
    return (
        <div>
            <h1 className='text-xl lg:text-3xl font-bold text-primary-focus'>Welcome to admin dashboard</h1>
        </div>
    );
};

export default WelcomeAdmin;